import { ProductType } from 'src/models/price/product.types';
import { ServiceCode, ServiceItemCode } from 'src/models/price/productCodes';

const getBrandedVacancyTemplateCount = (product: ProductType): number | null => {
    const { code, products } = product;
    if (code !== ServiceCode.BrandingBuilderVacancy || !products) {
        return null;
    }
    const productItems = Object.values(products);
    const productItemVacancyBuilder = productItems.find(({ code }) => code === ServiceItemCode.VacancyBuilderBasic);
    return productItemVacancyBuilder ? Number(productItemVacancyBuilder.count) : null;
};

export default getBrandedVacancyTemplateCount;
